var _g, _g2, _ellipse, _g3, _g4, _g5, _ellipse2, _g6, _g7, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTasksMascot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 141,
    viewBox: "0 0 205 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9675_32263)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9675_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3119 33.5984C52.791 32.3554 51.5939 30.6809 50.9307 28.6804C50.363 26.9676 51.4727 25.0786 52.2717 23.463C52.3851 23.2335 52.4776 23.0006 52.5508 22.7708C52.7939 22.0078 53.0279 21.2235 53.4534 20.5454C53.8223 19.9574 54.2461 19.2117 54.4667 18.579C55.0223 16.9857 55.3417 16.4417 54.973 15.1305C54.8711 14.7682 54.6679 14.5165 54.4216 14.3427C53.4992 13.6917 52.4659 14.733 52.2505 15.8399C52.2359 15.9152 52.2184 15.9888 52.1947 16.0617C52.0531 16.4964 51.4727 18.0863 50.5513 18.1094C49.4316 18.1374 49.6524 13.5427 49.8448 11.1345C49.9061 10.3673 49.3049 9.69905 48.535 9.69664C47.8186 9.69439 47.2379 10.2752 47.2405 10.9915L47.2621 17.0706C47.3106 17.6637 46.308 17.0103 46.1504 16.4363C45.787 15.1127 45.1028 12.6607 44.4665 10.6005C44.2284 9.82995 43.4122 9.40483 42.64 9.63532C41.8533 9.87015 41.4061 10.6976 41.6402 11.4852L43.6129 18.1196C43.7387 18.499 42.876 19.218 42.5468 18.7967L39.2543 13.8993C38.7799 13.1937 37.8176 13.0171 37.1253 13.5087C36.4827 13.965 36.3004 14.8395 36.7067 15.5162L39.3175 19.8636C39.8384 20.5729 40.2617 21.3478 40.5767 22.1677C40.687 22.4549 40.7834 22.7464 40.889 23.0353C41.1137 23.6503 41.5356 24.7848 41.8587 25.5344C42.6255 27.3133 45.0042 28.8488 45.6136 30.6873L47.341 35.8983C49.2213 41.5708 54.7609 45.2105 60.7225 44.6902C64.0103 44.4033 66.1919 41.1585 65.2182 38.0035L64.4451 35.4983C60.8368 36.6748 57.0498 35.836 54.3119 33.5984Z",
    fill: "url(#paint0_radial_9675_32263)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_9675_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.976 33.5984C152.497 32.3554 153.694 30.6809 154.357 28.6804C154.925 26.9676 153.815 25.0786 153.016 23.463C152.903 23.2335 152.81 23.0006 152.737 22.7708C152.494 22.0078 152.26 21.2235 151.835 20.5454C151.466 19.9574 151.042 19.2117 150.821 18.579C150.266 16.9857 149.946 16.4417 150.315 15.1305C150.417 14.7682 150.62 14.5165 150.866 14.3427C151.789 13.6917 152.822 14.733 153.038 15.8399C153.052 15.9152 153.07 15.9888 153.093 16.0617C153.235 16.4964 153.815 18.0863 154.737 18.1094C155.856 18.1374 155.636 13.5427 155.443 11.1345C155.382 10.3673 155.983 9.69905 156.753 9.69664C157.47 9.69439 158.05 10.2752 158.048 10.9915L158.026 17.0706C157.977 17.6637 158.98 17.0103 159.138 16.4363C159.501 15.1127 160.185 12.6607 160.822 10.6005C161.06 9.82995 161.876 9.40483 162.648 9.63532C163.435 9.87015 163.882 10.6976 163.648 11.4852L161.675 18.1196C161.549 18.499 162.412 19.218 162.741 18.7967L166.034 13.8993C166.508 13.1937 167.471 13.0171 168.163 13.5087C168.805 13.965 168.988 14.8395 168.581 15.5162L165.971 19.8636C165.45 20.5729 165.026 21.3478 164.711 22.1677C164.601 22.4549 164.505 22.7464 164.399 23.0353C164.174 23.6503 163.752 24.7848 163.429 25.5344C162.663 27.3133 160.284 28.8488 159.674 30.6873L157.947 35.8983C156.067 41.5708 150.527 45.2105 144.566 44.6902C141.278 44.4033 139.096 41.1585 140.07 38.0035L140.843 35.4983C144.451 36.6748 148.238 35.836 150.976 33.5984Z",
    fill: "url(#paint1_radial_9675_32263)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_9675_32263)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.3511,
    cy: 33.5906,
    rx: 43.3511,
    ry: 33.5906,
    transform: "matrix(-0.999686 0.0250555 0.0266024 0.999646 143.326 0.662109)",
    fill: "url(#paint2_radial_9675_32263)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.3511,
    cy: 33.5906,
    rx: 43.3511,
    ry: 33.5906,
    transform: "matrix(-0.999686 0.0250555 0.0266024 0.999646 143.326 0.662109)",
    fill: "url(#paint3_radial_9675_32263)",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_9675_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2323 36.5193C83.2422 41.2078 91.1056 44.893 101.132 44.6417C111.158 44.3904 118.815 40.3162 122.57 35.4331",
    stroke: "#7162B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_9675_32263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5028,
    cy: 8.66874,
    rx: 6.5028,
    ry: 8.66874,
    transform: "matrix(-0.999686 0.0250555 0.0266024 0.999646 98.2373 17.3999)",
    fill: "#ECECEC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_9675_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6932 23.784C85.6932 23.784 86.7509 17.6875 91.7349 17.5626C96.7189 17.4377 98.0995 23.4731 98.0995 23.4731C94.6924 19.8582 88.9036 20.0033 85.6932 23.784Z",
    fill: "#9183D2"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.1676,
    cy: 3.03406,
    rx: 2.1676,
    ry: 3.03406,
    transform: "matrix(-0.999686 0.0250555 0.0266024 0.999646 94.1025 24.8735)",
    fill: "#7060B6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_9675_32263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5028,
    cy: 8.66874,
    rx: 6.5028,
    ry: 8.66874,
    transform: "matrix(-0.999686 0.0250555 0.0266024 0.999646 115.572 16.9668)",
    fill: "#ECECEC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_9675_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.028 23.3499C103.028 23.3499 104.086 17.2534 109.07 17.1285C114.054 17.0036 115.434 23.039 115.434 23.039C112.027 19.4241 106.239 19.5692 103.028 23.3499Z",
    fill: "#9183D2"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.1676,
    cy: 3.03406,
    rx: 2.1676,
    ry: 3.03406,
    transform: "matrix(-0.999686 0.0250555 0.0266024 0.999646 111.432 24.4404)",
    fill: "#7060B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9675_32263",
    x: 0.490723,
    y: 1.73047,
    width: 204.307,
    height: 139.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9675_32263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9675_32263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9675_32263",
    x: 36.4907,
    y: 9.57275,
    width: 29.9609,
    height: 38.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9675_32263"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_9675_32263",
    x: 139.836,
    y: 9.57275,
    width: 29.9609,
    height: 38.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9675_32263"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_9675_32263",
    x: 57.5352,
    y: 1.73047,
    width: 87.6938,
    height: 70.1934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9675_32263"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_9675_32263",
    x: 76.2324,
    y: 33.4331,
    width: 49.3374,
    height: 15.2207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9675_32263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9675_32263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_9675_32263",
    x: 69.4624,
    y: 12.561,
    width: 45.0098,
    height: 49.3345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9675_32263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9675_32263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_9675_32263",
    x: 69.6934,
    y: 12.5605,
    width: 44.4062,
    height: 38.2236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9675_32263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9675_32263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_9675_32263",
    x: 86.7974,
    y: 12.1279,
    width: 45.0098,
    height: 49.3345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9675_32263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9675_32263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_9675_32263",
    x: 87.0283,
    y: 12.1265,
    width: 44.4062,
    height: 38.2236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9675_32263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9675_32263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9675_32263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6938 8.24825) rotate(71.6607) scale(41.1012 20.3485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6470DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9675_32263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.594 8.24825) rotate(108.339) scale(41.1012 20.3485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6470DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9675_32263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3511) rotate(90) scale(67.1813 86.7022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.251268,
    stopColor: "#ADACFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D6DE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9675_32263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3511 33.5906) rotate(90) scale(33.5906 43.3511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasksMascot);
export default __webpack_public_path__ + "static/media/NoTasksMascot.eced17918e04facf7aeb430b982ae544.svg";
export { ForwardRef as ReactComponent };